import { MenuItem, TextField } from '@material-ui/core';
import { useSelector } from 'react-redux';

export default function SelectTheme({ selectedTheme, setSelectedTheme }) {
  const themes = useSelector((state) => state.themeReducer.themes);
  return (
    <div className='max-w-md mt-8'>
      <TextField
        select
        onChange={(e) => setSelectedTheme(e.target.value)}
        value={selectedTheme}
        variant='outlined'
        label='Session type'
        fullWidth
      >
        {themes.map((theme) => (
          <MenuItem value={theme} key={theme.id}>
            {theme.name}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}
